import React, { useState, useEffect } from 'react';
import ChartValuationRetained from './ChartValuationRetained';
import { fetchData } from './FetchData';

function filterData(data) {
  return data.filter((d) => {
    return true;
  });
}

function prepareChartValuationRetainedData(data) {
  // usually more wrangling is required but the example data is simple
  return data;
}

const useData = (dataSet) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchNewData = async () => {
      try {
        setLoading(true);
        setError(false);
        const data = await fetchData(dataSet);
        const dataClean = filterData(data);
        setData(prepareChartValuationRetainedData(dataClean));
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError(err);
        setLoading(false);
      }
    };
    fetchNewData();
  }, [dataSet]);

  return [data, loading, error];
};

const ChartValuationRetainedData = () => {
  const [dataSet, setDataSet] = useState('dataValuationRetained');
  const [data, loading, error] = useData(dataSet);

  return (
    <>
      <ChartValuationRetained data={data} error={error} loading={loading} />
    </>
  );
};

export default ChartValuationRetainedData;
